import React from "react";

class CharactersCard extends React.Component {
  render() {
    return (
      <div className="col-12 col-sm-6 col-md-4 char-card-wrapper">
        <div className="char-card">
          <img
            className="char-card-img"
            src={this.props.img}
            width="1080"
            height="1080"
            alt={this.props.alt}
          />
        </div>
      </div>
    );
  }
}

export default CharactersCard;
